const IPAUploadBuild = () => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <h5>Uploading IPA File</h5>
            <small>(Estimated time: 3min)</small>
        </div>
    )
}

export default IPAUploadBuild;